export default __webpack_public_path__ + "static/media/251034.a30638ff.png";